var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 50,
    viewBox: "0 0 25 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.645 0.202006C12.2946 0.0519009 11.9146 -0.0160978 11.5339 0.0032093C11.1532 0.0225164 10.7819 0.128618 10.4485 0.313401C10.1151 0.498185 9.82841 0.756756 9.61028 1.06934C9.39215 1.38193 9.24839 1.74026 9.19 2.11693C9.12113 2.68702 8.93743 3.23724 8.65 3.73436C8.4 4.14685 8.025 4.56933 7.365 5.18431C6.065 6.38926 5.2725 7.8317 5.06 9.38664C4.8756 10.8176 5.16166 12.2698 5.875 13.524C7.105 15.7414 9.6 17.5013 12.2575 17.5013C15.7125 17.5013 20 15.0864 20 10.4866C20 8.12919 18.945 5.91428 17.635 4.20684C16.315 2.48941 14.5275 1.00947 12.645 0.204506M5 20.0012C3.67392 20.0012 2.40215 20.528 1.46447 21.4656C0.526784 22.4033 0 23.675 0 25.001V45.0002C0 46.3262 0.526784 47.5979 1.46447 48.5356C2.40215 49.4732 3.67392 50 5 50H20C21.3261 50 22.5979 49.4732 23.5355 48.5356C24.4732 47.5979 25 46.3262 25 45.0002V25.001C25 23.675 24.4732 22.4033 23.5355 21.4656C22.5979 20.528 21.3261 20.0012 20 20.0012H5Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold02);
export default __webpack_public_path__ + "static/media/Gold02.db9e4647ea872bb25d705b2e5548366b.svg";
export { ForwardRef as ReactComponent };